// extracted by mini-css-extract-plugin
module.exports = {"root":"FinlandMainCol-module--root--39SBi","container":"FinlandMainCol-module--container--33thD"};